const appUrlModifier = function() {
	const queryStringName = document.querySelector('script[data-mobile-query-string]').getAttribute("data-mobile-query-string");
	const anchors = document.querySelectorAll('a');

	const forEach = (arr, cb, scope) => {
		for (let i = 0; i < arr.length; i++) {
			cb.call(scope, arr[i], i);
		}
		return arr;
	}

	const filter = (arr, cb) => {
		const temp = [];
		forEach(arr, a => {
			if (cb(a)) {
				temp.push(a);
			}
		});
		return temp;
	}

	const contains = (substr, s) => {
		return s.indexOf(substr) > -1;
	}

	const appendMobileQuery = a => {
		a.href = a.href + `?${queryStringName}=true`;
	}

	const append = () => {
		const as = filter(document.querySelectorAll('a'), anchor => {
			return contains(window.location.origin, anchor.href) && !contains(`?${queryStringName}=true`, anchor.href);
		});

		forEach(as, appendMobileQuery);
	};

	const init = () => {
		const internalLinks = filter(anchors, anchor => {
			return contains(window.location.origin, anchor.href);
		});

		return forEach(internalLinks, appendMobileQuery);
	}

	return {
		init,
		append,
	};
};

window.addEventListener('load', function() {
	window.AppUrlModifier = appUrlModifier();
	window.AppUrlModifier.init();
});



// WEBPACK FOOTER //
// ./src/common/appUrlModifier.js